// Static content for BoT Summit 2026 landing page

export const EVENT = {
  name: "BoT Summit 2026",
  tagline: "The Backbone of Technology — Convened.",
  date: "August 22, 2026",
  dateShort: "22 . 08 . 2026",
  venue: "Taj Palace Convention Centre",
  city: "Bengaluru, India",
  edition: "Best of Tech",
};

export const STATS = [
  { value: "500+", label: "Delegates Expected" },
  { value: "10+", label: "Keynote Speakers" },
  { value: "5+", label: "Panel Discussions & Workshops" },
  { value: "100+", label: "Partner Organizations" },
];

export const AGENDA = [
  {
    day: "Morning Session",
    date: "",
    theme: "Infrastructure, AI & The New Internet",
    sessions: [
      { time: "09:30", title: "Registration & Breakfast Mixer", speaker: "—", track: "Network" },
      { time: "10:05", title: "Keynote — AI Adaptation at Scale: Opportunities, Challenges and Governance for the Next Decade", speaker: "—", track: "Keynote" },
      { time: "10:30", title: "Panel — Building a Digital First Nation: Innovation, Infrastructure and Policy for the Future Economy", speaker: "—", track: "Policy" },
      { time: "11:15", title: "Roundtable — From Disruption to Leadership: How Technology is Redefining Every Industry", speaker: "—", track: "Exec" },
      { time: "12:00", title: "Sponsor's Stage", speaker: "—", track: "Sponsor" },
      { time: "12:30", title: "Networking Lunch", speaker: "—", track: "Network" },
      { time: "13:15", title: "Keynote — The Rise of Autonomous Systems: From Smart Automation to Self Driving Enterprises", speaker: "—", track: "Keynote" },
      { time: "13:30", title: "Awards", speaker: "—", track: "Gala" },
      { time: "14:15", title: "Tea Break", speaker: "—", track: "Break" },
    ],
  },
  {
    day: "Evening Session",
    date: "",
    theme: "Platforms, Governance & The Road Ahead",
    sessions: [
      { time: "14:30", title: "Fireside Chat — The Cloud-Native Future: Building Scalable, Secure and Intelligent Digital Infrastructure", speaker: "—", track: "Cloud" },
      { time: "15:05", title: "Panel — Women Leaders in Technology: Driving Innovation, Adaptation and Inclusive Growth in the Digital Era", speaker: "—", track: "Panel" },
      { time: "15:45", title: "Panel — Vision to Execution: How Asian Tech Founder(s) and CEOs are Shaping the Next Wave of Innovation", speaker: "—", track: "Startup" },
      { time: "16:15", title: "Lightning Talks — Founder's Stage", speaker: "—", track: "Startup" },
      { time: "16:40", title: "Tea Break", speaker: "—", track: "Break" },
      { time: "17:00", title: "Keynote — The Next Frontier of Computing: Quantum, Edge and High Performance Systems", speaker: "—", track: "Keynote" },
      { time: "17:15", title: "Sponsor's Stage", speaker: "—", track: "Sponsor" },
      { time: "17:45", title: "Guest of Honour Address", speaker: "—", track: "Address" },
      { time: "18:00", title: "Awards", speaker: "—", track: "Gala" },
      { time: "18:45", title: "Closing Remarks & Torch Pass", speaker: "—", track: "Closing" },
    ],
  },
];

export const SPEAKERS = [
  {
    name: "Kiran Mani",
    title: "Managing Director, Asia Pacific & Japan",
    org: "OpenAI",
    img: "https://customer-assets-eiarnc6j.emergentagent.net/job_bot-summit-2026/artifacts/5z1qbewr_ChatGPT_Image_Aug_3_2026_03_40_35_PM_1_optimized_250.png",
    topic: "To be announced",
  },
  {
    name: "Mohit Joshi",
    title: "CEO & Managing Director",
    org: "Tech Mahindra",
    img: "https://customer-assets-eiarnc6j.emergentagent.net/job_bot-summit-2026/artifacts/lxivajek_ChatGPT_Image_Aug_3_2026_03_40_23_PM_1_optimized_250.png",
    topic: "To be announced",
  },
  {
    name: "Samar Mittal",
    title: "Country Business Leader",
    org: "Nokia India",
    img: "https://customer-assets-eiarnc6j.emergentagent.net/job_bot-summit-2026/artifacts/tfdmbu7u_ChatGPT_Image_Aug_3_2026_03_40_48_PM_optimized_250.png",
    topic: "To be announced",
  },
  {
    name: "Sumit Agarwal",
    title: "CEO",
    org: "Vyapar",
    img: "https://customer-assets-eiarnc6j.emergentagent.net/job_bot-summit-2026/artifacts/uyemoa3o_ChatGPT_Image_Aug_3_2026_03_40_56_PM_optimized_250.png",
    topic: "To be announced",
  },
  {
    name: "Arun Kumar Bansal",
    title: "MD & CEO",
    org: "Paytm Payments Bank",
    img: "https://customer-assets-eiarnc6j.emergentagent.net/job_bot-summit-2026/artifacts/xf44kv7n_ChatGPT_Image_Aug_3_2026_04_00_35_PM_optimized_250.png",
    topic: "To be announced",
  },
  {
    name: "Srinivas Jaagumantri",
    title: "VP – AI Transformation, Software Engineering",
    org: "Capgemini",
    img: "https://customer-assets-eiarnc6j.emergentagent.net/job_bot-summit-2026/artifacts/my1iq96z_ChatGPT_Image_Aug_3_2026_03_41_13_PM_optimized_250.png",
    topic: "To be announced",
  },
  {
    name: "Dilip Manepalli",
    title: "VP – AI and Innovation",
    org: "Vodafone",
    img: "https://customer-assets-eiarnc6j.emergentagent.net/job_bot-summit-2026/artifacts/0ogepdwb_ChatGPT_Image_Sep_2_2026_07_16_17_PM_2_optimized_1_optimized.png",
    topic: "To be announced",
  },
  {
    name: "Amit Kaushik",
    title: "CIO",
    org: "Zee Entertainment",
    img: "https://customer-assets-eiarnc6j.emergentagent.net/job_bot-summit-2026/artifacts/n2pueldx_ChatGPT_Image_Aug_3_2026_04_00_45_PM_optimized_250.png",
    topic: "To be announced",
  },
];

export const DIGNITARIES = [
  {
    name: "Hon. Shrikant Menon",
    title: "Union Minister",
    org: "Ministry of Electronics & IT",
    img: "https://images.pexels.com/photos/4183527/pexels-photo-4183527.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    quote: "The decade of digital sovereignty begins now.",
  },
  {
    name: "Dr. Priyanka Desai",
    title: "Chairperson",
    org: "National IT Advisory Council",
    img: "https://images.unsplash.com/photo-1701096351544-7de3c7fa0272?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjB3b21hbiUyMGhlYWRzaG90fGVufDB8fHx8MTc3NjQyNzM2N3ww&ixlib=rb-4.1.0&q=85",
    quote: "Talent is infrastructure. Invest like it matters.",
  },
  {
    name: "Sir Henry Walton",
    title: "President Emeritus",
    org: "Global IT Federation",
    img: "https://images.pexels.com/photos/4687549/pexels-photo-4687549.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    quote: "The network is no longer a utility — it is the institution.",
  },
];

export const GLIMPSES = [
  // Row 1-2 (hero + 2 side squares) — compressed
  "https://customer-assets.emergentagent.com/job_bot-summit-2026/artifacts/5p19alao_Screenshot%202026-04-19%20at%209.23.19%20AM.png",
  "https://customer-assets.emergentagent.com/job_bot-summit-2026/artifacts/q0pxa0mj_Screenshot%202026-04-19%20at%209.24.19%20AM.png",
  "https://customer-assets.emergentagent.com/job_bot-summit-2026/artifacts/g9sl7g09_Screenshot%202026-04-19%20at%209.25.28%20AM.png",
  // Row 3 — square | CENTERED wide | square
  "https://customer-assets.emergentagent.com/job_bot-summit-2026/artifacts/7cm3qip2_Screenshot%202026-04-22%20at%2010.31.42%20PM.png",
  "https://customer-assets.emergentagent.com/job_bot-summit-2026/artifacts/npkmb5v8_Screenshot%202026-04-19%20at%209.31.51%20AM.png",
  "https://images.unsplash.com/photo-1762968286778-60e65336d5ca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHw0fHxjb3Jwb3JhdGUlMjB0ZWNoJTIwZXZlbnQlMjBzdGFnZSUyMGF1ZGllbmNlfGVufDB8fHx8MTc3NjQyNzM2OHww&ixlib=rb-4.1.0&q=85",
  // Row 4 — 4 square user photos (compressed)
  "https://customer-assets.emergentagent.com/job_bot-summit-2026/artifacts/ge5gclhl_Screenshot%202026-04-19%20at%209.33.42%20AM.png",
  "https://customer-assets.emergentagent.com/job_bot-summit-2026/artifacts/xnu179l5_Screenshot%202026-04-19%20at%209.34.32%20AM.png",
  "https://customer-assets.emergentagent.com/job_bot-summit-2026/artifacts/2h35t98f_Screenshot%202026-04-19%20at%209.40.32%20AM.png",
  "https://customer-assets.emergentagent.com/job_bot-summit-2026/artifacts/mxuhs5a3_Screenshot%202026-04-19%20at%209.27.31%20AM.png",
  // Row 5 — 2 wide (square aspect to match the new images)
  "https://customer-assets.emergentagent.com/job_bot-summit-2026/artifacts/xrtyaheu_Screenshot%202026-04-23%20at%2012.06.07%20AM.png",
  "https://customer-assets.emergentagent.com/job_bot-summit-2026/artifacts/ims2uyac_Screenshot%202026-04-23%20at%2012.06.37%20AM.png",
];

export const FEATURED_LEADERS = [
  {
    name: "Deena Dayalan",
    title: "Global Head – Digital Transformation & Cloud India",
    org: "Kimberly-Clark",
    img: "https://customer-assets-eiarnc6j.emergentagent.net/job_bot-summit-2026/artifacts/bkeimxvj_deena.jpeg",
    linkedin: "https://www.linkedin.com/in/deendayalnaidu/",
  },
  {
    name: "Bassem Awada",
    title: "SVP – MENA",
    org: "TerraPay",
    img: "https://customer-assets-eiarnc6j.emergentagent.net/job_bot-summit-2026/artifacts/ycaohwxy_Bassem.jpeg",
    linkedin: "https://www.linkedin.com/in/bassem-awada-mba-b7625027/",
  },
  {
    name: "Caroline Rouse",
    title: "MD – AI Workforce Solutions, Asia",
    org: "Microsoft",
    img: "https://customer-assets-eiarnc6j.emergentagent.net/job_bot-summit-2026/artifacts/mlf8h3vl_Caroline.jpeg",
    linkedin: "https://www.linkedin.com/in/caroline-e-rouse/",
  },
  {
    name: "Dr. Imad Syed",
    title: "CEO",
    org: "PiLog Group",
    img: "https://customer-assets-eiarnc6j.emergentagent.net/job_bot-summit-2026/artifacts/4ci4v4vh_Imad.jpeg",
    linkedin: "https://www.linkedin.com/in/dr-imad-syed/",
  },
  {
    name: "John V. Francis",
    title: "CEO",
    org: "Ztartup Network",
    img: "https://customer-assets-eiarnc6j.emergentagent.net/job_bot-summit-2026/artifacts/0cucenbw_John.jpeg",
    linkedin: "https://www.linkedin.com/in/vfrancisjohn/",
  },
  {
    name: "Irina Ghose",
    title: "Managing Director",
    org: "Anthropic India",
    img: "https://customer-assets-eiarnc6j.emergentagent.net/job_bot-summit-2026/artifacts/u3yqwo4p_Irina.jpeg",
    linkedin: "https://www.linkedin.com/in/irinaghose/",
  },
  {
    name: "Vishal Dhupar",
    title: "Managing Director – Asia South",
    org: "Nvidia",
    img: "https://customer-assets-eiarnc6j.emergentagent.net/job_bot-summit-2026/artifacts/gsg00ibk_cropped-Vishal_Dhupar-300x300.jpg",
    linkedin: "https://www.linkedin.com/in/vishaldhupar/",
  },
  {
    name: "Sherie Ng",
    title: "Founding Partner",
    org: "Singlife Philippines",
    img: "https://customer-assets-eiarnc6j.emergentagent.net/job_bot-summit-2026/artifacts/8tf3b215_Sherie.jpeg",
    linkedin: "https://www.linkedin.com/in/sherieng/",
  },
  {
    name: "Abir Habbal",
    title: "MD – Data & AI",
    org: "Accenture",
    img: "https://customer-assets-eiarnc6j.emergentagent.net/job_bot-summit-2026/artifacts/g1kzn33t_Abier.jpeg",
    linkedin: "https://www.linkedin.com/in/abir-habbal/",
  },
  {
    name: "Naveen Bolalingappa",
    title: "CEO",
    org: "STL Digital",
    img: "https://customer-assets-eiarnc6j.emergentagent.net/job_bot-summit-2026/artifacts/weifr3vw_Naveen_Bollalingappa_1_1_10.jpg",
    linkedin: "https://www.linkedin.com/in/naveen-bolalingappa-819536a/",
  },
  {
    name: "Vaibhav Khandelwal",
    title: "Co-Founder & CTO",
    org: "Shadowfax",
    img: "https://customer-assets-eiarnc6j.emergentagent.net/job_bot-summit-2026/artifacts/4buong1g_Vaibhav%20Shadow%20Fox.jpeg",
    linkedin: "https://www.linkedin.com/in/khandelwal-vaibhav/",
  },
  {
    name: "Vidit Aatrey",
    title: "Founder & CEO",
    org: "Meesho",
    img: "https://customer-assets-eiarnc6j.emergentagent.net/job_bot-summit-2026/artifacts/sidnlves_Vidit.jpeg",
    linkedin: "https://www.linkedin.com/in/vidit-aatrey-a3639120/",
  },
  {
    name: "Irene Liu",
    title: "MD – Strategy & Consulting",
    org: "Accenture Singapore",
    img: "https://customer-assets-eiarnc6j.emergentagent.net/job_bot-summit-2026/artifacts/f8am4m15_Irene.jpeg",
    linkedin: "https://www.linkedin.com/in/blessedireneliu/",
  },
  {
    name: "Selina Yuan",
    title: "Vice President",
    org: "Alibaba Cloud",
    img: "https://customer-assets-eiarnc6j.emergentagent.net/job_bot-summit-2026/artifacts/5gw3tkrb_Selina.jpeg",
    linkedin: "https://www.linkedin.com/in/selina-yuan-72820479/",
  },
  {
    name: "Dr. Debajit Banerjee",
    title: "Head & Enterprise Architect",
    org: "SAP Labs India",
    img: "https://customer-assets-eiarnc6j.emergentagent.net/job_bot-summit-2026/artifacts/17z4gnlm_Debajit_wTie_profile_official1_optimized_2_20.png",
    linkedin: "https://www.linkedin.com/in/debajitbanerjee/",
  },
  {
    name: "Neel Pandya",
    title: "Founder & CEO",
    org: "Climaty AI",
    img: "https://customer-assets-eiarnc6j.emergentagent.net/job_bot-summit-2026/artifacts/eg5rb0wc_Neel.jpeg",
    linkedin: "https://www.linkedin.com/in/neelpandya/",
  },
  {
    name: "Dale Vaz",
    title: "Founder & CEO",
    org: "Sahi",
    img: "https://customer-assets-eiarnc6j.emergentagent.net/job_bot-summit-2026/artifacts/aed448ef77750ee8_WhatsApp%20Image%202026-01-09%20at%205.52.01%20PM%20%281%29%20%281%29%20%281%29.jpeg",
    linkedin: "https://www.linkedin.com/in/dalevaz/",
  },
  {
    name: "Venkatesh Rao",
    title: "CEO",
    org: "Sureworks",
    img: "https://customer-assets-eiarnc6j.emergentagent.net/job_bot-summit-2026/artifacts/40bee3ac45ec808c_Venkatesh%20Rao%20CEo%20Sureworks.jpeg",
    linkedin: "https://www.linkedin.com/in/venkatesh-rao-ba084818/",
  },
  {
    name: "Donato Lucia",
    title: "Partner & VP Technology",
    org: "Revolut",
    img: "https://customer-assets-eiarnc6j.emergentagent.net/job_bot-summit-2026/artifacts/7ae1789d50e7e976_Donato-Lucia%20revolut.webp",
    linkedin: "https://www.linkedin.com/in/donatolucia/",
  },
  {
    name: "Mei Dent",
    title: "Chief Product & Technology Officer",
    org: "TeamViewer",
    img: "https://customer-assets-eiarnc6j.emergentagent.net/job_bot-summit-2026/artifacts/8d1793a3dcce1c74_Mei-Dent%20CPTO%20Team%20Viewer.webp",
    linkedin: "https://www.linkedin.com/in/mei-dent-6201b8/",
  },
];

export const NAV = [
  { id: "about", label: "About Us" },
  { id: "agenda", label: "Agenda" },
  { id: "speakers", label: "Keynote Speakers" },
  { id: "featured-leaders", label: "Featured Leaders" },
  { id: "glimpses", label: "Snapshots" },
  { id: "registration", label: "Registration" },
  { id: "contact", label: "Contact Us" },
];

export const PARTNERS = [
  "MICROSOFT", "TATA CONSULTANCY SERVICES", "ORACLE", "META", "GOOGLE",
  "SAP", "INFOSYS", "NVIDIA", "ADOBE", "CAPGEMINI", "ACCENTURE", "SALESFORCE",
];

export const MEDIA = [
  "BLOOMBERG", "CNA", "CNBC", "DETIKCOM", "YAHOO FINANCE",
  "MALAYSIAKINI", "CNN-NEWS18", "ARAB NEWS", "NDTV",
  "TIMES OF INDIA", "HINDUSTAN TIMES", "KHALEEJ TIMES",
];

export const LEADER_TIERS = [
  {
    id: "in-person-leader",
    name: "In Person - Leader Participation",
    price: "$299",
    priceNote: "USD",
    badge: "On-stage felicitation at the summit",
    color: "#002FA7",
    highlighted: true,
    deliverables: [
      "Felicitation as Global Transformational/Future Tech Leader on the BoT Summit main stage",
      "One-page creative feature about the selected leader in the digital magazine to be launched at the event and posted on the summit website",
      "Personalised recognition certificate (physical + digital)",
      "Full-access delegate pass for all activities at the summit",
      "Invite to the Leaders' Lounge for curated networking",
      "A confirmed spot in the industry-specific panel discussion, on the Leader's chosen topic",
      "Professional photograph of the felicitation moment",
      "Featured name + designation on the BoT Summit Leaders microsite",
      "One social-media feature across BoT Summit LinkedIn + Facebook",
      "Inclusion in the post-event digital report",
    ],
  },
  {
    id: "remote-leader",
    name: "Remote - Leader Participation",
    price: "$199",
    priceNote: "USD",
    badge: "Recognition without travelling",
    color: "#002FA7",
    deliverables: [
      "Felicitation as Global Transformational/Future Tech Leader, announced at the BoT Summit",
      "One-page creative feature about the selected leader in the digital magazine to be launched at the event and posted on the summit website",
      "Personalised recognition certificate (physical + digital)",
      "A Short video introducing you and highlighting your achievements, played on the main summit stage",
      "Featured name + designation on the BoT Summit Leaders microsite",
      "One social-media feature across BoT Summit LinkedIn + Facebook",
      "Inclusion in the post-event digital report",
    ],
  },
];

export const BRAND_ADDON_PRICE = 500;

export const BRAND_ADDON = [
  "Felicitation of brand as Global Best Tech Brand (Segment Specific)",
  "One-page creative feature about the selected Brand in the digital magazine to be launched at the event and posted on the summit website",
  "One social-media feature about the brand across BoT Summit LinkedIn + Facebook",
  "Company logo displayed alongside the leader during on-stage felicitation",
  "Brand logo placement on the Global Best Tech Brands on-stage backdrop",
  "Dedicated brand mention in the felicitation announcement script",
  "Company logo + tagline on the BoT Summit Leaders microsite profile",
  "1 additional delegate pass for colleague of the leader",
  "Inclusion of brand logo in the post-event report",
  "One-year feature on the BoT Summit website in the Leaders Hall of Fame",
  "A confirmed 20-25 minute Speaker's slot for the brand",
];
